/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useState } from "react";
import { useTranslation } from "react-i18next";

const DeviationAndSopGuidelines = () => {
	const { t } = useTranslation();
	const [justification, setJustification] = useState("");
	return (
		<div className="grid grid-cols-1 md:grid-cols-2 gap-3">
           <div className="bg-[#FFF1F1] border border-red-200 rounded-2xl p-8 relative">
              <div className="flex items-center gap-4 text-red-600 mb-4">
                 <span className="material-symbols-outlined font-black">report_problem</span>
                 <h4 className="text-[10px] font-black uppercase tracking-widest">{ t("mediaBatchInit.preparation.deviationAlert") }</h4>
              </div>
              <p className="text-xs font-bold text-red-800 mb-6 leading-relaxed">
                Powder weight (40.05g) is +0.05g above target. Please document justification below.
              </p>
              <textarea
                value={justification}
                onChange={(e) => setJustification(e.target.value)}
                placeholder="Reason for deviation..."
                className="w-full bg-white border border-red-100 rounded-xl p-4 text-[10px] font-medium text-slate-600 outline-none min-h-[60px] resize-none"
              ></textarea>
           </div>
           <div className="bg-[#EEF6FF] border border-blue-100 rounded-2xl p-8 flex items-start gap-5">
              <span className="material-symbols-outlined text-blue-500 text-xl font-black mt-1">info</span>
              <div>
					<h4 className="text-[10px] font-black text-blue-600 uppercase tracking-widest mb-3">{ t("mediaBatchInit.preparation.sopGuideline") }</h4>
                <p className="text-xs font-medium text-blue-800 leading-relaxed italic">
                  { t("mediaBatchInit.preparation.deviationHelperText") }
                </p>
              </div>
           </div>
        </div>
	);
};

export default DeviationAndSopGuidelines;
